import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 18.75a6.96 6.96 0 0 1-6.07-3.5c-1.258-2.16-1.258-4.812 0-7A7.02 7.02 0 0 1 12 4.75c2.488 0 4.785 1.34 6.043 3.5 1.258 2.188 1.258 4.84 0 7A6.95 6.95 0 0 1 12 18.75M9.785 9.535c-.273.274-.273.684 0 .93l1.285 1.285-1.285 1.285c-.273.274-.273.684 0 .93a.6.6 0 0 0 .902 0l1.286-1.285 1.285 1.285c.273.273.683.273.93 0 .273-.246.273-.656 0-.93l-1.286-1.285 1.286-1.285c.273-.246.273-.656 0-.93-.247-.246-.657-.246-.93 0l-1.285 1.285-1.286-1.285a.644.644 0 0 0-.902 0"
    }, null, -1)
  ]))]))
}
export default { render: render }